module.exports = __webpack_public_path__ + "img/myhealthbank.4d57fe90.png";